import React from "react";
import { MapPin, ArrowUpRight, Phone, Mail, MessageCircle } from "lucide-react";
import { CONTACT } from "@/i18n/translations";
import { useHome } from "@/i18n/home";

const MAPS = "https://www.google.com/maps/search/?api=1&query=PowerTech+Str.+Tor+83+39030+St.+Martin+in+Thurn";

export const Locations = () => {
  const l = useHome().locations;
  return (
  <section id="contact" className="relative overflow-hidden bg-[#F7F8FA] py-24 sm:py-28" data-testid="locations">
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl mb-12">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0B87B0]">
          {l.overline}
        </span>
        <h2 className="mt-6 font-display font-semibold tracking-tight text-4xl sm:text-5xl leading-[1.04] text-[#090A0C]">{l.title}</h2>
        <p className="mt-5 text-lg text-[#4B5563] leading-relaxed">{l.lead}</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        {/* Firmensitz – premium map card */}
        <a
          href={MAPS}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="location-card"
          className="group relative overflow-hidden rounded-[2rem] border border-[#CBDDE9] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(0,0,0,0.08)]"
        >
          <div className="relative h-28 w-full" style={{ background: "#090A0C" }}>
            <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "linear-gradient(rgba(0,195,255,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(0,195,255,0.35) 1px, transparent 1px)", backgroundSize: "26px 26px" }} aria-hidden="true" />
            <span className="absolute -bottom-7 left-8 grid h-16 w-16 place-items-center rounded-2xl border border-[#CBDDE9] bg-white shadow-lg">
              <MapPin size={26} color="var(--pt-blue)" />
            </span>
          </div>
          <div className="p-8 pt-11">
            <p className="text-xs uppercase tracking-widest text-[#0B87B0] font-bold">{l.hq}</p>
            <h3 className="mt-1 font-display text-2xl font-bold text-[#090A0C]">St. Martin in Thurn</h3>
            <p className="mt-2 text-[15px] text-[#4B5563]">Str. Tor 83<br />39030 St. Martin in Thurn (BZ) · {l.country}</p>
            <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#00C3FF]/25 bg-[#00C3FF]/10 px-5 py-2.5 text-sm font-semibold text-[#0B87B0] transition-colors group-hover:bg-[#00C3FF]/20">
              {l.route} <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </div>
        </a>

        {/* Direkter Kontakt */}
        <div className="rounded-[2rem] border border-[#CBDDE9] bg-white p-8 sm:p-10 shadow-[0_8px_30px_rgba(0,0,0,0.04)]" data-testid="contact-data-card">
          <p className="text-xs uppercase tracking-widest text-[#0B87B0] font-bold">{l.direct}</p>
          <div className="mt-3 flex items-center gap-3">
            <span className="h-8 w-1 rounded-full" style={{ background: "var(--pt-orange)" }} />
            <span className="font-display text-2xl font-bold text-[#090A0C]">Otto</span>
          </div>
          <div className="mt-6 space-y-3">
            <a href={`tel:${CONTACT.phoneRaw}`} data-testid="location-phone" className="group flex items-center gap-3 rounded-2xl border border-[#D3E2EC] bg-[#F4F8FB] p-4 transition-colors hover:border-[#00C3FF]/60">
              <span className="grid h-11 w-11 place-items-center rounded-full" style={{ background: "rgba(0,195,255,0.18)" }}><Phone size={18} color="var(--pt-blue)" /></span>
              <span><span className="block text-xs uppercase tracking-wider text-[#94A3B8]">{l.phone}</span><span className="block text-[#090A0C] font-semibold">{CONTACT.phone}</span></span>
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="location-email" className="group flex items-center gap-3 rounded-2xl border border-[#D3E2EC] bg-[#F4F8FB] p-4 transition-colors hover:border-[#00C3FF]/60">
              <span className="grid h-11 w-11 place-items-center rounded-full" style={{ background: "rgba(0,195,255,0.18)" }}><Mail size={18} color="var(--pt-blue)" /></span>
              <span className="min-w-0"><span className="block text-xs uppercase tracking-wider text-[#94A3B8]">E-Mail</span><span className="block text-[#090A0C] font-semibold truncate">{CONTACT.email}</span></span>
            </a>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="location-whatsapp" className="group flex items-center gap-3 rounded-full p-4 shadow-lg shadow-orange-500/25 transition-transform hover:scale-[1.02] hover:-translate-y-0.5" style={{ background: "var(--pt-orange)" }}>
              <span className="grid h-11 w-11 place-items-center rounded-full bg-white/20"><MessageCircle size={18} color="#fff" /></span>
              <span className="text-white font-bold">WhatsApp Chat</span>
              <ArrowUpRight size={17} className="ml-auto text-white transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
